import React from 'react';
import PropTypes from 'prop-types';

const ProgressWrapper = props => (
  <div className="progress-grid">{props.children}</div>
);

ProgressWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProgressWrapper;



// WEBPACK FOOTER //
// ./src/Shared/UI/Progress/ProgressWrapper.js